<template>
  <div class="page-login" id="page-login">
    <div class="login">
      <el-card shadow="always" class="none-card">
        <div class="title">
          用户登录
          <!-- <span @click="closeLogin" class="close-login"><icon class="el-icon-circle-close" style="color: #FFFFFF;"></icon></span> -->
        </div>
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item prop="username" class="relative-div">
            <span class="input-line"><img src="/static/images/introduce/input-line.png" /></span>
            <el-input class="s-username" prefix-icon="iconfont icon-grxx" v-model="form.username" placeholder="请输入账号"
              clearable></el-input>
          </el-form-item>
          <el-form-item class="s-password relative-div" prop="password">
            <span class="input-line2"><img src="/static/images/introduce/input-line.png" /></span>
            <el-input prefix-icon="iconfont icon-suo" @keyup.enter.native="onSubmit" type="password"
              v-model="form.password" placeholder="请输入密码" clearable></el-input>
          </el-form-item>
          <el-form-item class="relative-div">
            <el-button :loading="loading" type="primary" class="login-btn" @click="onSubmit"
              @keyup.enter.native="onSubmit">登录</el-button>
              <span class="forget-password" @click="openDlg">忘记密码？</span>
          </el-form-item>
        </el-form>
        <div class="warn-info">
          <span>数据安全注意事项：</span><br/>
          <span>1. 务必妥善保管网站登录账户密码，存在空闲账户请48h内反馈网站管理员进行注销；</span><br/>
          <span>2. 账户管理遵循最小权限原则，禁止将账号密码传递给非业务相关人员使用；</span><br/>
          <span>3. 存在数据安全事件请24h内反馈蜂巢能源网站管理员排查，并协助进行风险的管控；</span><br/>
          <span>4. 因上述原因导致的数据安全事件或风险升级，蜂巢能源不承担法律责任；</span><br/>
          <span>5. 网站管理员联系方式：svoltcloud@svolt.cn</span>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  import {
    authorize,
    login,
    token,
    searchStatisticsList
  } from '@/api/login';
  import filterRoute from '@/router/router.js';
  import USERAPI from '@/api/user';
  import {
    setToken,
    removeToken,
    filterAsyncRouter,
    setInfo,
    getInfo
  } from '@/utils/auth';
  import S from './../../../src/utils/website.js'
  export default {
    components:{
    },
    data() {
      return {
        loading: false,
        form: {},
        rules: {
          username: [{
            required: true,
            message: '账号必填'
          }],
          password: [{
            required: true,
            message: '密码必填'
          }]
        }
      };
    },
    methods: {
      closeLogin() {
        this.$emit('close');
      },
      //打开忘记密码
      openDlg(){
        this.$emit('open')
      },
      //调用用户资源权限跳转项目页面
      toProject(projectId, systemId, query) {
        let self = this;
        let params = {
          projectId: projectId,
          resourceId: systemId
        };
        USERAPI.searchUserResources(params).then(res => {
          //保存权限模块
          localStorage.removeItem('ActiveProjectModule');
          let activeModule = {
            resourceIds: [],
            item: []
          };
          let data = res.data.data;
          data.forEach(item => {
            activeModule.resourceIds.push(item.resourceId);
            activeModule.item.push({
              checked: item.checked,
              resourceId: item.resourceId,
              resourceNameShow: item.resourceNameShow,
              showOrder: item.showOrder
            });
            //增加二级展示
            if (item.children && item.children.length > 0) {
              item.children.forEach(n => {
                activeModule.resourceIds.push(n.resourceId)
                activeModule.item.push({
                  checked: n.checked,
                  resourceId: n.resourceId,
                  resourceNameShow: n.resourceNameShow,
                  showOrder: n.showOrder
                });
              })
            }
          });
          localStorage.setItem('ActiveProjectModule', JSON.stringify(activeModule));
          let params = {}
          if (query == true) {
            params.name = 'SvoltProject';
            params.query = {
              projectId: projectId
            }
          } else {
            params.name = 'Svolt';
          }
          self.$router.push(params);
          return true;
        });
      },
      //在跳转到一个平台多个项目的情况下直接跳转到组织页面
      toGroup(projectId, systemId, query) {
        let params = {
          resourceId: systemId
        };
        USERAPI.searchUserResources(params).then(res => {
          //记录可以访问的路由地址
          var result = [];
          let filter = filterAsyncRouter(res.data.data, result);
          localStorage.setItem('ActiveRouter', JSON.stringify(filter));
          //筛选路由菜单
          localStorage.setItem('ActiveMenu', JSON.stringify(res.data.data));
          //添加可以访问的路由
          filterRoute.forEach(item => {
            filter.forEach(it => {
              if (it.name == item.name) {
                this.$router.addRoute('Layout', item);
              }
            });
          });
          //保存权限模块
          if (systemId == 2) {
            //储能统计系统
            localStorage.removeItem('ActiveModule');
            let activeModule = {
              resourceIds: [],
              item: []
            };
            let data = res.data.data;
            data.forEach(item => {
              activeModule.resourceIds.push(item.resourceId);
              activeModule.item.push({
                checked: item.checked,
                resourceId: item.resourceId,
                resourceNameShow: item.resourceNameShow,
                showOrder: item.showOrder
              });
            });
            localStorage.setItem('ActiveModule', JSON.stringify(activeModule));
            this.toProject(projectId, systemId, query);
          }
        });
      },
      onSubmit() {
        if (this.form.username != "" && this.form.password != "") {
          if (this.form.username && this.form.password) {
            this.loading = true;
            login(this.form)
              .then(res => {
                if (res.data.code == 200 && !res.data.hasOwnProperty('errors')) {
                  let tokenParams = {
                    code: res.data.data,
                    grant_type: $SITE.grantType,
                    redirect_uri: $SITE.host.API_GATEWAY_URL + '/getCode'
                  };
                  //获取token
                  token(tokenParams).then(data => {
                    setToken(data.data.access_token);
                    //调用用户详情接口
                    USERAPI.searchUserDetail().then(res => {
                      this.loading = false;
                      if (res.data.code == 200) {
                        var info = JSON.parse(JSON.stringify(res.data.data));
                        let platform = [];
                        info.platformResources.forEach(item => {
                          platform.push({
                            resourceImageUrl: item.resourceImageUrl,
                            resourceNameShow: item.resourceNameShow,
                            resourceName: item.resourceName,
                            resourceType: item.resourceType,
                            id: item.id,
                            routingAddress: item.routingAddress,
                            resourceUrl: item.resourceUrl
                          });
                        });
                        setInfo({
                          platformResources: platform,
                          user: info.user,
                          groupId: info.groupId,
                          groupInfo: info.groupInfo
                        });
                        //存储项目列表
                        localStorage.setItem('ProjectList', JSON.stringify(info.projectInfoList));
                        let platformNum = res.data.data.platformResources.length;
                        if (platformNum > 1) {
                          this.$router.push({
                            name: 'System'
                          });
                        } else {
                          let projectList = JSON.parse(localStorage.getItem('ProjectList'));
                          if (platform[0].id == 2) {
                            localStorage.setItem('SystemId', 2);
                            if (projectList.length > 1) {
                              //进组织
                              // this.toProject(projectList[0].projectId,platform[0].id,false);
                              this.toGroup(projectList[0].projectId, platform[0].id, false);
                            } else {
                              //进项目
                              this.toProject(projectList[0].projectId, platform[0].id, true);
                            }
                          } else {
                            this.$router.push({
                              name: 'Home'
                            });
                          }
                        }
                      } else {
                        this.$message.warning("用户名或密码错误！");
                      }
                    });
                  });
                }
              })
              .catch(err => {
                this.loading = false;
              });
          } else {
            this.$message.warning("请输入用户名和密码！");
          }
        } else {
          if (this.form.username == "") {
            this.$message.warning("请输入用户名！");
          } else if (this.form.password == "") {
            this.$message.warning("请输入密码！");
          }
        }
      }
    },
    created() {},
    mounted() {
      try {
        console.log('测试环境变量2');
        console.log(S.host);

      } catch (error) {
        console.error('在mounted钩子中发生了一个错误:', error);
      }
    },
    beforeDestroy() {}
  };
</script>

<style lang="scss">
  $bg-color: #1e282c;

  .page-login {
    top: 0;
    left: 0;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;

    .close-login {
      display: inline-block;
      position: absolute;
      right: 10px;
      top: 10px;

      &:hover {
        cursor: pointer;
      }

      .el-icon-circle-close {
        color: #777;
        font-size: 20px;
      }

      img {
        color: #ffffff;
      }
    }

    .login {
      margin: 0px auto;
      position: relative;
      text-align: center;
      z-index: 999;

      width: 700px;
      height: 500px;
      background: rgba(0, 31, 64, 0.79);
      border-radius: 6px;
      border: 1px solid #27396d;

      .el-input {
        width: 95%;
        color: #ffffff !important;
      }

      .none-card {
        background: transparent;
        border: none;
        color: #fff;
      }

      .el-form-item__error {
        margin-left: 36px;
      }

      .s-username,
      .s-password {
        input {
          padding: 0px !important;
          border-radius: 4px !important;
          text-indent: 30px !important;
        }

        input[type='text']:focus {
          box-shadow: none;
        }

        input[type='text']::placeholder {
          color: rgb(2, 97, 228);
        }

        input[type='password']::placeholder {
          color: rgb(2, 97, 228);
        }

        .el-input__prefix {
          width: 24px;
        }
      }

      .s-username {
        margin-top: 20px;
      }

      .title {
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 21px;
        font-weight: bold;
        letter-spacing: 2px;
        margin-bottom: 20px;
      }

      .warn-info {
        line-height: 2;
        text-align: left;
        font-size: 14px;
      }

      .login-btn {
        width: 100px;
        letter-spacing: 3px;
        margin-top: 10px;
      }
    }
  }

  .relative-div {
    position: relative;
  }
  .forget-password{
    color:#ffffff;
    position:absolute;
    right:10px;
    top:10px;
    font-size:12px;
    &:hover{
      cursor: pointer;
    }
  }
  .input-line {
    display: inline-block;
    position: absolute;
    top: 20px;
    left: 35px;

    &img {
      width: 1px;
      height: 23px;
    }
  }

  .input-line2 {
    display: inline-block;
    position: absolute;
    top: 0px;
    left: 35px;

    &img {
      width: 1px;
      height: 23px;
    }
  }

  .page-login .login .s-username .el-input__prefix,
  .page-login .login .s-password .el-input__prefix {
    color: #1776fe !important;
  }

  .page-login .login .s-username input,
  .page-login .login .s-password input {
    background: transparent;
    border-color: #0261e4;
    color: #ffffff;

    &::-webkit-input-placeholder {
      color: #224373;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue